import React, { FC, useState, FormEvent } from 'react'
import cx from 'classnames'
//import { StorageProvider } from 'providers/storage'
import { useTranslation } from 'react-i18next'
import { useParams/*, useNavigate */ } from 'react-router-dom'
import { useRecoverPassword } from 'services/auth'
import { useFormFields } from 'hooks/useFormFields'
import { Card } from 'components/Card'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { TextInput } from 'components/TextInput'
import { Button } from 'components/Button'
import { Alert } from 'components/Alert'
import { Flex } from 'components/Flex'
import { Logo } from 'features/shared/Logo'
import styles from './RecoverPassword.module.scss'

export const RecoverPassword: FC = () => {
  const { t } = useTranslation()
  //const navigate = useNavigate()
  const { uuid } = useParams()
  const [error, setError] = useState<string>()
  const [recoverPassword, { status }] = useRecoverPassword(uuid)
  const [form, onFieldChange] = useFormFields({
    password: '',
    passwordConfirmation: '',
  })

  const onFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    setError(undefined)
    if (form.password !== form.passwordConfirmation) {
      setError('forgot_password.recover.error')
      return
    }

    recoverPassword(form, {
      onError() {
        setError('common.messages.error')
      },
      onSuccess() {
        /*if (StorageProvider.has('token')) {
          navigate('/')
          alert("Entro 2")
        } else {
          setError('common.messages.error')
          alert("Entro 1")
        }*/
        var popup = null;
        popup = document.getElementById("popupElm");
        popup!.style.display = "block";
      },
    })
  }

  function goToDashboard() {
    window.location.href = "https://app.descifra.global/login"
  }



  return (
    <Flex justify="center" align="center" className={styles.recoverPassword}>
      <div id="popupElm" className={styles.dialogOverlay}>
        <div className={cx(styles.dialogContent)}>
          <Heading size="card">{t('recoverpassword.title')}</Heading>
          <br></br>
          <div className={styles.divGrande}>
            <button className={styles.buttonEliminar} onClick={goToDashboard}>Ir al Login</button>
          </div>
        </div>
      </div>
      <Card>
        <Stack space="large">
          <Stack space="small">
            <Heading size="secondary">{t('forgot_password.recover.title')}</Heading>
            <Text>{t('forgot_password.recover.subtitle')}</Text>
          </Stack>

          <form onSubmit={onFormSubmit}>
            <Stack space="medium">
              <TextInput
                name="password"
                type="password"
                value={form.password}
                onChange={onFieldChange}
                label={t('forgot_password.recover.form.password')}
                required
              />

              <TextInput
                name="passwordConfirmation"
                type="password"
                value={form.passwordConfirmation}
                onChange={onFieldChange}
                label={t('forgot_password.recover.form.passwordConfirmation')}
                required
              />

              <Button type="submit" loading={status === 'loading'}>
                {t('forgot_password.recover.form.cta')}
              </Button>

              {error && (
                <Alert tone="critical" full>
                  {t(error)}
                </Alert>
              )}
            </Stack>
          </form>

          <Logo />
        </Stack>
      </Card>
    </Flex>
  )
}

RecoverPassword.displayName = 'RecoverPassword'
